// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mail-filter-row[data-v-d847263a]{display:flex;gap:5px;align-items:baseline}`, "",{"version":3,"sources":["webpack://./src/components/mailFilter/Action.vue"],"names":[],"mappings":"AACA,kCACC,YAAA,CACA,OAAA,CACA,oBAAA","sourcesContent":["\n.mail-filter-row {\n\tdisplay: flex;\n\tgap: 5px;\n\talign-items: baseline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
